module.exports = __webpack_public_path__ + "media/images/icons/target-de44f77f7ed90dc7da63da6d1fc0303a.svg";